import { render, staticRenderFns } from "./IPlatform.vue?vue&type=template&id=534d6b30&"
import script from "./IPlatform.vue?vue&type=script&lang=ts&"
export * from "./IPlatform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports